import React from "react";
import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share";

const BannerWithSocialShare = ({
  bannerImage,
  title,
  subtitle,
  url,
  description,
}) => {
  return (
    <div style={styles.container}>
      {/* Banner Section */}
      <div style={styles.bannerContainer}>
        <div
          style={{
            ...styles.banner,
            backgroundImage: `url(${bannerImage})`,
          }}
        >
          <div style={styles.overlay}>
            <h1 style={styles.title}>{title}</h1>
            {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
          </div>
        </div>
      </div>

      {/* Social Share Section */}
      <div style={styles.socialSection}>
        <h3 style={styles.shareTitle}>Share this banner:</h3>
        <div style={styles.socialButtons}>
          <FacebookShareButton
            url={url}
            quote={`Check out: ${title}`}
            hashtag="#CustomBanner"
          >
            <FacebookIcon size={40} round />
          </FacebookShareButton>

          <LinkedinShareButton
            url={url}
            title={title}
            summary={description}
            source="Your Website"
          >
            <LinkedinIcon size={40} round />
          </LinkedinShareButton>

          <TwitterShareButton
            url={url}
            title={title}
            hashtags={["CustomBanner", "Share"]}
            via="yourusername"
          >
            <TwitterIcon size={40} round />
          </TwitterShareButton>
        </div>

        {/* Instagram Note */}
        <div style={styles.instagramNote}>
          <p>💡 For Instagram: Save the banner image and share it directly!</p>
        </div>
      </div>
    </div>
  );
};

// Styles
const styles = {
  container: {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
  },
  bannerContainer: {
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
    marginBottom: "30px",
  },
  banner: {
    position: "relative",
    height: "300px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    padding: "30px 40px",
    borderRadius: "8px",
    textAlign: "center",
    color: "white",
    maxWidth: "80%",
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    margin: "0 0 10px 0",
    textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
  },
  subtitle: {
    fontSize: "1.2rem",
    margin: 0,
    opacity: 0.9,
  },
  socialSection: {
    textAlign: "center",
    padding: "20px",
    backgroundColor: "#f8f9fa",
    borderRadius: "12px",
  },
  shareTitle: {
    marginBottom: "15px",
    color: "#333",
  },
  socialButtons: {
    display: "flex",
    justifyContent: "center",
    gap: "15px",
    marginBottom: "15px",
  },
  instagramNote: {
    fontSize: "0.9rem",
    color: "#666",
  },
};

export default BannerWithSocialShare;
